export default "__VITE_ASSET__90599831__"